import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from '../../app/servicios/api/api.service';
import { UsuarioI } from '../../app/modelos/usuario.interface';
import { EstadoUsuarioI } from '../../app/modelos/estadoUsuario.intreface';
import { TipoUsuarioI } from '../../app/modelos/tipoUsuario.interface';
import { AppServiceService } from '../servicios/AppService.service';
import { UsuarioExcel } from '../modelos/usuarioExcel';
import { histActUsuarioI } from '../modelos/histActUsuario';
import { ToastrService } from 'ngx-toastr';
import { UsuariosServiceService } from '../servicios/usuarios/UsuariosService.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnDestroy,OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  usuarios : UsuarioI[];
  estadosUsuario : EstadoUsuarioI[];
  tiposUsuarios : TipoUsuarioI[];
  UsuarioActivar : UsuarioI = new UsuarioI;
  NuevaHistoria : histActUsuarioI = new histActUsuarioI;
  HistorialActivacion : histActUsuarioI[];
  NuevoEstado : EstadoUsuarioI;
  EstadoActual : String;
  hoy: string;
  btnguardar: Boolean;
  page : number;

  stringBase64 : any = "";
  botonDescarga : Boolean = false;

  @ViewChild('openModalcloseModalActivar') openModalcloseModalActivar: ElementRef;
  @ViewChild('closeModalcloseModalActivar') closeModalcloseModalActivar: ElementRef;
  @ViewChild('closeModalHistorial') closeModalHistorial: ElementRef;
  @ViewChild('openmodalconfirmar') openmodalconfirmar: ElementRef;
  @ViewChild('cerrarmodalconfirmar') cerrarmodalconfirmar: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private descargaService:AppServiceService,
    private toastr: ToastrService,
    private usuarioService: UsuariosServiceService
    ) { }


  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ usuarios"
        }
    };

    /*this.api.getAllUsers().subscribe(data=>{
      this.usuarios = data;
      this.dtTrigger.next();
    },error=>{
      console.log(error);
    });*/
    this.loadUsuarios();

    this.api.getEstados().subscribe(data=>{
      this.estadosUsuario = data;
    },error=>{
      console.log(error);
    });

    this.api.getTipos().subscribe(data=>{
      this.tiposUsuarios = data;
    },error=>{
      console.log(error);
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /*loadUsuarios() {
    this.api.getAllUsers().subscribe(data => {
      this.usuarios = data;
      this.dtTrigger.next();
    }, error => {
      console.log(error);
    });
  }*/

  loadUsuarios() {
    this.api.getAllUsers().subscribe(data => {
      this.usuarios = data;
      // Destruir la instancia existente de DataTables si existe
      const table = $('#table2excel').DataTable();
      if (table) {
        table.destroy();
      }
      this.dtTrigger.next();
    }, error => {
      console.log(error);
    });
  }

  nuevoUsuarioCHV(){
    this.router.navigate(['nuevouserchv']);
  }

  nuevoUsuarioFIVI(){
    this.router.navigate(['nuevouserfivi']);
  }

  nuevoUsuarioDANE(){
    this.router.navigate(['nuevouserdane']);
  }

  editarUsuario(id){
    this.router.navigate(['editarusuario',id]);
  }

  nombreUsuarioCambiaEstado : String = "";

  estadoUsuario( usu: UsuarioI){
    this.openModalcloseModalActivar.nativeElement.click();
    this.EstadoActual = usu.estadoUsuario.idEstadoUsuario;
    this.btnguardar = false;
    this.NuevaHistoria = new histActUsuarioI();
    this.UsuarioActivar = usu;
    this.nombreUsuarioCambiaEstado = usu.username;
  }

  cambiarEstadoUsuario(){
    this.btnguardar = true;
    if (this.NuevaHistoria.observacion == "" || this.NuevaHistoria.observacion == null){
      this.btnguardar = false;
      this.toastr.warning('Ingresar observación.', 'Advertencia!');
    } else if (this.NuevaHistoria.observacion.length < 20){
      this.btnguardar = false;
      this.toastr.warning('La observación debe tener mínimo 20 carácteres.', 'Advertencia!');
    } else if (this.NuevaHistoria.observacion.length > 100){
      this.btnguardar = false;
      this.toastr.warning('La observación debe tener máximo 100 carácteres.', 'Advertencia!');
    } else if (this.EstadoActual == "1"){
      this.NuevoEstado = {idEstadoUsuario: "2", nombreEstado: "Inactivo", desEstado: "Inactivo"};

      this.NuevaHistoria.usuario = this.UsuarioActivar;
      this.NuevaHistoria.fecha = new Date().toString();
      this.NuevaHistoria.accion = "Inactivar";
      this.NuevaHistoria.novedad = "Inactivar";
      this.NuevaHistoria.usuarioMod = localStorage.getItem('usuario');

      //this.UsuarioActivar.estadoUsuario = this.NuevoEstado;

      this.closeModalcloseModalActivar.nativeElement.click();
      this.openmodalconfirmar.nativeElement.click();
    } else if (this.EstadoActual == "2"){
      this.NuevoEstado = {idEstadoUsuario: "1", nombreEstado: "Activo", desEstado: "Activo"};

      this.NuevaHistoria.usuario = this.UsuarioActivar;
      this.NuevaHistoria.fecha = new Date().toString();
      this.NuevaHistoria.accion = "Activar";
      this.NuevaHistoria.novedad = "Activar";
      this.NuevaHistoria.usuarioMod = localStorage.getItem('usuario');

      //this.UsuarioActivar.estadoUsuario = this.NuevoEstado;

      this.closeModalcloseModalActivar.nativeElement.click();
      this.openmodalconfirmar.nativeElement.click();
    }
  }

  cancelarConfirmar(){
    this.btnguardar = false;
    this.estadoUsuario(this.UsuarioActivar);
    this.openModalcloseModalActivar.nativeElement.click();
  }

  confirmarGuardar(){
    if (this.EstadoActual == "1"){
        this.usuarioService.cambiarEstadoUsuario2(this.UsuarioActivar.id, this.NuevoEstado.idEstadoUsuario).subscribe(
          data=>{
            if(data){
              this.cerrarmodalconfirmar.nativeElement.click();
              this.api.saveHistUsuario(this.NuevaHistoria).subscribe(result=>{
                if (result){
                  this.toastr.success('Usuario '+this.nombreUsuarioCambiaEstado+' inactivado.', 'OK!');
                  this.loadUsuarios();
                }
              }, error => {
                this.toastr.error('No se pudo cambiar el estado.', 'Error!');
              });
            }
        }, error =>{
          this.toastr.error('No se pudo cambiar el estado.', 'Error!');
        });
    } else if (this.EstadoActual == "2"){
        this.usuarioService.cambiarEstadoUsuario2(this.UsuarioActivar.id, this.NuevoEstado.idEstadoUsuario).subscribe(
          data=>{
            if(data){
              this.cerrarmodalconfirmar.nativeElement.click();
              this.api.saveHistUsuario(this.NuevaHistoria).subscribe(result=>{
                if (result){
                  this.toastr.success('Usuario '+this.nombreUsuarioCambiaEstado+' activado.', 'OK!');
                  this.loadUsuarios();
                }
              }, error => {
                this.toastr.error('No se pudo cambiar el estado.', 'Error!');
              });
            }
        }, error =>{
          this.toastr.error('No se pudo cambiar el estado.', 'Error!');
        });
    }
  }

  HistEstadoUsuario(id){
    this.api.getHistoriaUsuario(id).subscribe(historial=>{
      this.HistorialActivacion = historial;
    }, error=>{
      this.toastr.error('No se pudo cargar el historial de activacion del usuario.', 'Error!');
    })
  }

  cerrarModal(){
    this.closeModalHistorial.nativeElement.click();
  }

  download(){
    this.botonDescarga = true;
    this.usuarioService.descargarExcelUsuarios().subscribe(
      result => {
        if(result != undefined || result != null) {
          this.stringBase64 = result.data;
          this.descargarArchivo();
        }
      }, error =>{
        this.botonDescarga = false;
        console.log(error);
      }
    );
  }

  descargarArchivo() {
    if (this.stringBase64) {
      const blob = this.base64toBlob(this.stringBase64);
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = "Usuarios";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
    this.botonDescarga = false;
    this.stringBase64 = "";
  }

  base64toBlob(base64Data: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

}
